import { __extends } from "tslib";
import LanguageDetectorNames from "../constants/LanguageDetectorNames";
import AbstractDetector from "./AbstractDetector";
var DocumentElementDetector = /** @class */ (function (_super) {
    __extends(DocumentElementDetector, _super);
    function DocumentElementDetector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * The detection logic for this class, returns the language string or null when nothing is found.
     *
     * @returns {(string|null)} The language or null if the detector could note validate the language.
     */
    DocumentElementDetector.prototype.detect = function () {
        var language = this.getDocumentElementValue();
        // Clear the language if the meta tag for this detector value contains 'en'.
        // @note - disabled because it causes problems for Terra.place.
        //         Even though it happends quite often, we should not make this assumption
        //         because it can break when things are implemented properly.
        // @todo - Create options for AbstractDetector with a setting like ignoreEnglish to make this
        //         configureable
        // if (this.containsEnglish(language)) {
        //     language = null;
        // }
        return _super.prototype.detect.call(this, language);
    };
    DocumentElementDetector.prototype.getName = function () {
        return LanguageDetectorNames.DocumentElement;
    };
    /**
     * Check if the meta tag content string contains the 'en' identifier.
     *
     * @param {string} value The string to check for indexOf value.
     */
    DocumentElementDetector.prototype.containsEnglish = function (value) {
        return value.indexOf("en") > -1;
    };
    /**
     * Get the document element language.
     *
     * In most cases this will refer to the <html> element and grabs the lang attribute from there.
     */
    DocumentElementDetector.prototype.getDocumentElementValue = function () {
        var documentElement = document.documentElement;
        if (documentElement) {
            var foundAdditionalAttributeWithValue = DocumentElementDetector.additionalAttributes.find(function (attribute) { return !!documentElement.getAttribute(attribute); });
            var additionalAttributeValue = foundAdditionalAttributeWithValue
                ? documentElement.getAttribute(foundAdditionalAttributeWithValue)
                : null;
            var defaultDocumentElementValue = documentElement.lang;
            // const localeAttributeValue = document.documentElement.getAttribute("locale");
            // return additionalAttributeValue || defaultDocumentElementValue || localeAttributeValue || null;
            return additionalAttributeValue || defaultDocumentElementValue || null;
        }
        return null;
    };
    DocumentElementDetector.additionalAttributes = ["hc:lang"];
    return DocumentElementDetector;
}(AbstractDetector));
export default DocumentElementDetector;
//# sourceMappingURL=DocumentElementDetector.js.map